(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ps-pdp').forEach(function(root){
    var thumbs = root.querySelectorAll('.ps-pdp__thumb');
    var slides = root.querySelectorAll('.ps-pdp__slide');
    var numEl = root.querySelector('[data-slide-num]');
    var current = 0;
    function go(i){
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function(s, idx){ s.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function(t, idx){ t.classList.toggle('is-active', idx === current); });
      if (numEl) numEl.textContent = current + 1;
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.dataset.slide, 10) || 0); }); });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function(){ go(current - 1); });
    if (next) next.addEventListener('click', function(){ go(current + 1); });

    var atcBtn = root.querySelector('[data-atc-btn]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var qtyInput = root.querySelector('[data-qty-input]');

    // Initialize ATC price/qty from default-active bundle
    var activeBundle = root.querySelector('.ps-pdp__bundle.is-active');
    if (activeBundle) {
      if (qtyInput) qtyInput.value = activeBundle.dataset.bundleQty || 1;
      if (atcPrice) atcPrice.textContent = ' — ' + (activeBundle.dataset.bundlePrice || '');
    }

    root.querySelectorAll('.ps-pdp__bundle').forEach(function(opt){
      opt.addEventListener('click', function(e){
        if (e.target.closest('a')) return;
        root.querySelectorAll('.ps-pdp__bundle').forEach(function(o){ o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var radio = opt.querySelector('.ps-pdp__bundle-radio-input');
        if (radio) radio.checked = true;
        if (qtyInput) qtyInput.value = opt.dataset.bundleQty || 1;
        if (atcPrice) atcPrice.textContent = ' — ' + (opt.dataset.bundlePrice || '');
      });
    });

    root.querySelectorAll('.ps-pdp__acc-head').forEach(function(head){
      head.addEventListener('click', function(){ head.parentElement.classList.toggle('is-open'); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-announcement-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var nav = document.querySelector('[data-ps-nav]');
  if (!nav) return;
  window.addEventListener('scroll', function () {
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ps-faq__head-btn').forEach(function(btn){
    btn.addEventListener('click', function(){ btn.parentElement.classList.toggle('is-open'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ps-pdp').forEach(function(root){
    var thumbs = root.querySelectorAll('.ps-pdp__thumb');
    var slides = root.querySelectorAll('.ps-pdp__slide');
    var numEl = root.querySelector('[data-slide-num]');
    var current = 0;
    function go(i){
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function(s, idx){ s.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function(t, idx){ t.classList.toggle('is-active', idx === current); });
      if (numEl) numEl.textContent = current + 1;
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.dataset.slide, 10) || 0); }); });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function(){ go(current - 1); });
    if (next) next.addEventListener('click', function(){ go(current + 1); });

    var atcBtn = root.querySelector('[data-atc-btn]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var baseLabel = atcBtn ? atcBtn.childNodes[0].nodeValue : '';
    root.querySelectorAll('.ps-pdp__bundle').forEach(function(opt){
      opt.addEventListener('click', function(e){
        if (e.target.closest('a')) return;
        root.querySelectorAll('.ps-pdp__bundle').forEach(function(o){ o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var radio = opt.querySelector('.ps-pdp__bundle-radio-input');
        if (radio) radio.checked = true;
        if (atcPrice) atcPrice.textContent = ' — ' + (opt.dataset.bundlePrice || '');
      });
    });

    root.querySelectorAll('.ps-pdp__acc-head').forEach(function(head){
      head.addEventListener('click', function(){ head.parentElement.classList.toggle('is-open'); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-tiktok-ugc"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ps-tiktok]').forEach(function (rail) {
    var track = rail.querySelector('[data-ps-tiktok-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-ps-tiktok-prev]');
    var next = rail.querySelector('[data-ps-tiktok-next]');
    var originals = Array.prototype.slice.call(track.querySelectorAll('.ps-tiktok__card'));
    if (!originals.length) return;

    // Clone cards on both sides for seamless infinite loop
    originals.forEach(function (card) {
      var c = card.cloneNode(true);
      c.setAttribute('data-clone', 'end');
      track.appendChild(c);
    });
    originals.slice().reverse().forEach(function (card) {
      var c = card.cloneNode(true);
      c.setAttribute('data-clone', 'start');
      track.insertBefore(c, track.firstChild);
    });

    var allCards = Array.prototype.slice.call(track.querySelectorAll('.ps-tiktok__card'));
    var originalCount = originals.length;

    function step() {
      var card = allCards[0];
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || 20, 10) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function originalsWidth() {
      return step() * originalCount;
    }

    // Position at the first "real" (non-clone) card
    function setInitial() {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = originalsWidth();
      track.style.scrollBehavior = 'smooth';
    }
    setInitial();
    window.addEventListener('resize', setInitial);

    // Seamless loop: snap back by one full set when crossing edges
    var isAdjusting = false;
    track.addEventListener('scroll', function () {
      if (isAdjusting) return;
      var setW = originalsWidth();
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= setW * 2 - 1 || track.scrollLeft >= maxScroll - 1) {
        isAdjusting = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft - setW;
        track.style.scrollBehavior = 'smooth';
        requestAnimationFrame(function () { isAdjusting = false; });
      } else if (track.scrollLeft <= 0) {
        isAdjusting = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft + setW;
        track.style.scrollBehavior = 'smooth';
        requestAnimationFrame(function () { isAdjusting = false; });
      }
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    allCards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      video.addEventListener('play',  function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); video.currentTime = 0; });
      card.addEventListener('click', function (e) {
        e.preventDefault();
        if (video.paused) {
          allCards.forEach(function (c) {
            var v = c.querySelector('video');
            if (v && v !== video) v.pause();
          });
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          video.pause();
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
